// extracted by mini-css-extract-plugin
export var products__slider = "products-module--products__slider--apAkp";
export var products__sliderContainer = "products-module--products__slider-container--uKGoO";
export var products__sliderPagination = "products-module--products__slider-pagination--TczNo";